<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;">
			<v-card class="mx-auto" flat>
				<v-card-text>
					<v-form ref="form">
						<v-text-field
							label="VIN-код"
							v-model="params.vin"
							outlined
							dense
							clearable
							:rules="[rules.required]"
							@keyup.ctrl.90="params.vin='WAUC8AFC0HN089495'"
							@keyup.enter.self="onOK"
							hide-details="auto"
						></v-text-field>
						<p class="my-3">Згідно з міжнародним стандартом ISO 3779 встановлені правила для ідентифікаційного номера транспортного засобу (VIN):</p>
						<ul>
							<li>Код завжди складається рівно із 17 символів</li>
							<li>Можна використовувати всі арабські цифри (0–9) та великі літери латинського алфавіту (від A до Z).</li>
							<li>Літери I, O та Q ніколи не використовуються. Це правило введене для того, щоб не плутати їх із цифрами 1 та 0.</li>
							<li>Не допускаються пробіли або будь-які розділові знаки.</li>
						</ul>
					</v-form>
				</v-card-text>
				<!-- <v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions> -->
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- Favorit -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-if="isFavorit" color="yellow-darken-1" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star</v-icon>
            					<v-icon v-else class="opacity-30" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star-outline</v-icon>
							</template>
							<span>Вибране</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				 <!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<download-excel 
									:data="excel.data"
									:name="excel.name"
									:type="excel.type"
								>
									<v-icon large color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</download-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 256px;">
			<v-card flat>
				<v-card-title class="text-h5">{{ title }} {{ id ? '№' + id: '' }}</v-card-title>
				<v-card-subtitle>{{ subtitle }}</v-card-subtitle>

				<v-card-text v-for="(estimate, index) in estimates" :key="index">
					<v-simple-table dense
						fixed-header
					>
						<template v-slot:default>
						<thead>
							<tr>
								<th class="text-left">Назва</th>
								<th class="text-left">Значення</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(equipment, index) in estimate.equipments" :key="index">
								<td>{{ equipment.name }}</td>
								<td>{{ equipment.description }}</td>
							</tr>
						</tbody>
						</template>
					</v-simple-table>
				</v-card-text>
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64" ></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import zPdf from '@/views/pdf/VehicleEquipment'
import downloadExcel from "vue-json-excel";
//import { forEach } from 'core-js/core/array';

export default {
	name: 'VehicleEquipment',
	mixins: [mixin],
	components: {
		zPdf,
		downloadExcel
	},
	data: () => ({
		title: 'Комплектація',
		subtitle: 'Інформація про складові частини транспортного засобу за VIN-кодом',
		loading: false,

		//favorit: {},

		excel: {
			name: '',
			type: 'xlsx',
			disabled: true,
			data: []
		},

		excelType: 'xlsx',

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	props: {
		
	},

	watch: {
		
	},
	
	computed: {
		...mapGetters('VehicleEquipment', [ 'item' ]),

		id() {
			return this.item.hasOwnProperty('id') ? this.item.id: null;
		},

		favorit() {
			return this.favorits.find(element => element.id === this.id);
		},

		excelName() {
			return this.title + (this.vin ? ' ' + this.vin : '') + '.' +  this.excelType
		},

		estimates() {
			return this.item.hasOwnProperty('estimates') ? this.item.estimates: [];
		},
	},

	created(){
		this.params.tab = 'vin';
	},

	methods: {
		...mapActions('VehicleEquipment', [ 'setItem' ]),

		onClear() {
			this.$refs.form.reset()
			//this.clear()
		},

		onOK() {
			if(this.$refs.form.validate()) {
			//if(this.validate()) {
				this.loading = true
				var that = this
				let params = { vin: this.params.vin };
				axios.post('/vehicle/estimate/equipment', params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					that.setItem(response.data)
				}, error => {
					console.log('error', error)

					that.snackbar.visible 	= true;
					that.snackbar.text 		= error.response.data.message;
					that.snackbar.color 	= null;
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onFavorit() {
			if(this.favorit) {
				this.removeFavorit(this.favorit) 
			} else {
				//console.log(this.$options.name, 'onFavorit','estimates', this.estimates)

				let vin, yearProd,category,brand,model,body,fuel,transmission,color,country,engineVolume, engineVolumeFrom, engineVolumeTo;

				this.estimates.forEach(estimate => {
					//console.log(this.$options.name, 'onFavorit','equipments', estimate.equipments)

					vin = estimate.equipments.find(element => element.name === 'VIN')?.description;
					yearProd = estimate.equipments.find(element => element.name === 'Model Year')?.description;
					category = estimate.equipments.find(element => element.name === 'Product Type')?.description;
					brand = estimate.equipments.find(element => element.name === 'Make')?.description;
					model = estimate.equipments.find(element => element.name === 'Model')?.description;
					body = estimate.equipments.find(element => element.name === 'Body')?.description;
					fuel = estimate.equipments.find(element => element.name === 'Fuel Type - Primary')?.description;
					transmission = estimate.equipments.find(element => element.name === 'Transmission')?.description;
					color = estimate.equipments.find(element => element.name === 'Color')?.description;
					country = estimate.equipments.find(element => element.name === 'Plant Country')?.description;
					engineVolume = estimate.equipments.find(element => element.name === 'Engine Displacement (ccm)')?.description;
					if(!isNaN(engineVolume)) {
						engineVolume = engineVolume / 1000;
						engineVolumeFrom = Math.floor(engineVolume / 1000);
						engineVolumeTo = Math.ceil(engineVolume / 1000);
					}

					//console.log(this.$options.name, 'onFavorit','vin', vin)
				})

				let favorit = { 
					id: this.item.id,
					code: vin,
					name: vin,
					vin: vin,
					yearProd: yearProd,
					yearProdFrom: yearProd,
					yearProdTo: yearProd,
					engineVolume: engineVolume,
					engineVolumeFrom: engineVolumeFrom,
					engineVolumeTo: engineVolumeTo,
				}

				var that = this
				this.loading = true

				axios.get(`/vehicle/category/code/${category}`).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					favorit['category'] = response.data
				}).then(() => axios.get(`/vehicle/brand/name/${brand}`).then(response => {
					favorit['brand'] = response.data
				})).then(() => axios.get(`/vehicle/brand/${brand}/model/name/${model}`).then(response => {
					favorit['model'] = response.data
				})).then(() => axios.get(`/vehicle/fuel/code/${fuel}`).then(response => {
					favorit['fuel'] = response.data
				//})).then(() => axios.get(`/vehicle/color/code/${color}`).then(response => {
				//	favorit['color'] = response.data
				})).then(() => axios.get(`/vehicle/country/code/${country}`).then(response => {
					favorit['country'] = response.data
				//})).then(() => axios.get(`/vehicle/body/code/${body}`).then(response => {
				//	favorit['body'] = response.data
				//})).then(() => axios.get(`/vehicle/transmission/code/${transmission}`).then(response => {
				//	favorit['transmission'] = response.data
				})).finally(() => {
					this.loading = false

					//console.log(this.$options.name, 'onFavorit','favorit', favorit)

					this.addFavorit(favorit)
				});
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},
	},
}
</script>